// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"240":"ab299a4b","359":"6234a472","453":"77dbcc70"}[chunkId] + ".chunk.js";
};